import React from 'react';
const Header = ({ title, subtitle, buttonText, navigateTo, buttonVariant = "none" , buttonVariant1 = "none" , buttonText1  }) => {
  return null;
};

export default Header;
